import { MarketplaceInfo } from 'pages/insights-pro/country-tab/model';
import { Flag } from 'components/Flag';
import { Measure } from 'services/model/model.service';
import { PaginatedAccordionList } from 'pages/insights-pro/common/components/PaginatedAccordionList';
import { EmptyState } from 'components/EmptyState';

interface ActiveCountriesProps {
  marketplaces: MarketplaceInfo[];
  qtyMeasure: Measure;
  gmvMeasure: Measure;
}

export function ActiveCountriesPerMarketplace({ marketplaces, qtyMeasure, gmvMeasure }: ActiveCountriesProps) {
  if (marketplaces.length === 0) {
    return <EmptyState />;
  }
  return (
    <PaginatedAccordionList
      items={marketplaces.filter(m => m.countries.some(c => qtyMeasure.getValue(c.entry?.values) > 0))}
      getId={m => `marketplace-${m.name}`}
      getTitle={m => m.name}
      getBadgeCount={m => m.countries.filter(c => qtyMeasure.getValue(c.entry?.values) > 0).length}
      getChildrenItems={m =>
        m.countries
          .filter(c => qtyMeasure.getValue(c.entry?.values) > 0)
          .sort((a, b) => gmvMeasure.getValue(b.entry?.values) - gmvMeasure.getValue(a.entry?.values))
          .map(c => <Flag key={c.name} countryCode={c.code?.toLowerCase()} tooltip={c.name} />)
      }
      childrenLimit={16}
      accordionItemLimit={3}
    />
  );
}
